import React, { useState, useEffect } from "react";
import Header from "../../components/Header/Header";
import Grid from "@mui/material/Grid";
import { Container, Card, TextField, Button, Tooltip } from "@mui/material";
import { Formik, Form, Field, FieldArray, ErrorMessage } from "formik";
import MenuItem from "@mui/material/MenuItem";
import CloseIcon from "@mui/icons-material/Close";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import DeleteIcon from "@mui/icons-material/Delete";
import DifferenceOutlinedIcon from "@mui/icons-material/DifferenceOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { getProject, getSingleProject } from "./Slice/projectSlice";
import { ToastContainer, toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  getProductType,
  addProductType,
} from "../Settings/ProductType/Slice/productTypeSlice";
import {
  updateQuotation,
  getProjectQuotation,
  getQuotationSingleProduct,
  updateQuotationSingleProduct,
  deleteQuotationSingleProduct,
} from "./Slice/projectQuotationSlice";
import { getUomList } from "../Settings/UOM/uomSlice";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import {
  addDummyProduct,
  updateDummyProduct,
  deleteDummyProduct,
  getDummyProduct,
} from "./Slice/projectDummySlice";
import CreateIcon from "@mui/icons-material/Create";
import { getQuotationOrderNumber } from "../Quote/Slice/quoteSlice";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    width: "800px",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const project1 = [
  {
    value: "Paint Supplier",
    label: "Paint Supplier",
  },
  {
    value: "Wood Supplier",
    label: "Wood Supplier",
  },
  {
    value: "Furniture Crafting Product",
    label: "Furniture Crafting Product",
  },
];

const rnd = Math.floor(Math.random() * 10000) + 1;
localStorage.setItem("rndno", rnd);

const EditQuotation = () => {
  const [quoteNo, setQuoteNo] = useState("");
  const dummyList = useSelector((state) => state.projectDummy);
  const quoteList = useSelector((state) => state.quote);
  const projectList = useSelector((state) => state.project);
  const productTypeList = useSelector((state) => state.productType);
  const makeQuotationList = useSelector((state) => state.projectQuotation);
  const uomList = useSelector((state) => state.uom);
  const id = useParams();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getProject());
    dispatch(getProductType());
    dispatch(getProjectQuotation(id.id));
    dispatch(getUomList());
    dispatch(getQuotationOrderNumber());
  }, []);

  console.log(makeQuotationList);
  const [project, setProject] = React.useState([]);
  const [productType, setProductType] = React.useState([]);
  const [newArea, setArea] = useState("");
  const [amount, setAmount] = useState("");
  const [uoms, setUom] = React.useState([]);
  const [openAuthentication, setOpenAuthentication] = React.useState(false);
  const handleOpenAuthentication = () => setOpenAuthentication(true);
  const handleCloseAuthentication = () => setOpenAuthentication(false);

  const [openProductModel, setOpenProductModel] = React.useState(false);
  const handleOpenProductModel = () => setOpenProductModel(true);
  const handleCloseProductModel = () => setOpenProductModel(false);

  const [openProductModelEdit, setOpenProductModelEdit] = React.useState(false);
  const handleOpenProductModelEdit = () => setOpenProductModelEdit(true);
  const handleCloseProductModelEdit = () => setOpenProductModelEdit(false);

  const [openProductModelEditDb, setOpenProductModelEditDb] =
    React.useState(false);
  const handleOpenProductModelEditDb = () => setOpenProductModelEditDb(true);
  const handleCloseProductModelEditDb = () => setOpenProductModelEditDb(false);

  const [openAdd, setOpenAdd] = React.useState(false);
  const handleOpenAdd = () => setOpenAdd(true);
  const handleCloseAdd = () => setOpenAdd(false);

  const [selectedImage, setSelectedImage] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);

  const calculate = (e) => {
    let qty = document.getElementById("qty").value;
    let rate = document.getElementById("rate").value;
    let total = 0;
    total = parseFloat(qty) * parseFloat(rate);
    document.getElementById("amount").value = total;
    setAmount(total);
  };

  const getProduct = (e) => {
    dispatch(getDummyProduct(e));
    setOpenProductModelEdit(true);
  };

  const deleteProduct = (e) => {
    dispatch(deleteDummyProduct(e));
  };

  const getProductDb = (e) => {
    dispatch(getQuotationSingleProduct(e));
    setOpenProductModelEditDb(true);
  };

  const deleteProductDb = (e) => {
    dispatch(deleteQuotationSingleProduct(e));
  };

  const navigate = useNavigate();
  const nextSaleOrder = () => {
    navigate("/project/create-quotation/" + makeQuotationList.quotationId);
  };

  useEffect(() => {
    setProject(projectList.projects);
  }, [projectList.projects]);

  useEffect(() => {
    setProductType(productTypeList.productTypes);
    setUom(uomList.uomLists);
  }, [productTypeList.productTypes]);

  useEffect(() => {
    if (selectedImage) {
      setImageUrl(URL.createObjectURL(selectedImage));
    }
  }, [selectedImage]);

  useEffect(() => {
    if (dummyList.singleItem) {
      setAmount(dummyList.singleItem.amount);
    }
  }, [dummyList.singleItem]);

  useEffect(() => {
    if (makeQuotationList.quotationSingleProduct.amount) {
      setAmount(makeQuotationList.quotationSingleProduct.amount);
    }
  }, [makeQuotationList.quotationSingleProduct.amount]);

  return (
    <>
      <Header />
      <Container maxWidth={false}>
        <Grid container className="pl-50 pr-50">
          <Grid item xs={12}>
            <Card className="mt-30 mb-50" style={{ backgroundColor: "#fff" }}>
              <Grid item xs={12}>
                <div className="card-header">
                  <p>Edit Quotation</p>
                  <h4>{makeQuotationList.quotationDetail.quotation_id}</h4>
                </div>
              </Grid>
              <Formik
                enableReinitialize={true}
                initialValues={{
                  quotation_id: id.id,
                  project_id: makeQuotationList.quotationDetail.project_id,
                  rndno: localStorage.getItem("rndno"),
                }}
                onSubmit={async (values) => {
                  dispatch(updateQuotation(values));
                  console.log(values);
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue,
                }) => (
                  <Form onSubmit={handleSubmit}>
                    <Grid container className="card-body">
                      <Grid item xs={12} className="form-custom">
                        <TextField
                          id="project_id"
                          name="project_id"
                          label="Select Project"
                          variant="standard"
                          className="w-100"
                          value={makeQuotationList.quotationDetail.project_name}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                      {makeQuotationList.quotationDetail.upload ? (
                        <>
                          <Grid item xs={12} className="form-custom">
                            <Button
                              href={
                                process.env.REACT_APP_IMAGE_URL +
                                "/" +
                                makeQuotationList.quotationDetail.upload
                              }
                              variant="text"
                              target="_blank"
                              style={{ fontWeight: "600" }}
                            >
                              Presentation Link
                            </Button>
                          </Grid>
                        </>
                      ) : null}
                      <Grid item xs={6} className="form-custom">
                        {/* <Button
                          // type="button"
                          variant="contained"
                          // color="primary"
                          onClick={handleOpenProductModel}
                        >
                          Add Product
                        </Button> */}
                        <Button
                          variant="text"
                          style={{ fontWeight: "600" }}
                          onClick={handleOpenProductModel}
                        >
                          + Add Product
                        </Button>
                      </Grid>
                      <Grid item xs={12} className="mt-20 mb-20">
                        <TableContainer component={Paper}>
                          <Table
                            sx={{ minWidth: 650 }}
                            aria-label="simple table"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell>Area</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell>Type</TableCell>
                                <TableCell>UOM</TableCell>
                                <TableCell>Qty</TableCell>
                                <TableCell>Rate</TableCell>
                                <TableCell>Amount</TableCell>
                                <TableCell>Image</TableCell>
                                <TableCell>Drawing</TableCell>
                                <TableCell>Action</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {makeQuotationList.quotationDetail.area_list &&
                                makeQuotationList.quotationDetail.area_list.map(
                                  (item, index) => (
                                    <TableRow key={index}>
                                      <TableCell>{item.area}</TableCell>
                                      <TableCell>{item.product_name}</TableCell>
                                      <TableCell>{item.product_type}</TableCell>
                                      <TableCell>{item.uom}</TableCell>
                                      <TableCell>{item.qty}</TableCell>
                                      <TableCell>{item.rate}</TableCell>
                                      <TableCell>{item.amount}</TableCell>
                                      <TableCell>
                                        <Zoom>
                                          <img
                                            src={
                                              process.env.REACT_APP_IMAGE_URL +
                                              "/" +
                                              item.drawing
                                            }
                                            alt="product-image"
                                            width="60"
                                          />
                                        </Zoom>
                                      </TableCell>
                                      <TableCell>
                                        {/* {item.pdf ? (
                                          <>
                                            <Button
                                              href={
                                                process.env
                                                  .REACT_APP_IMAGE_URL +
                                                "/" +
                                                item.pdf
                                              }
                                              variant="text"
                                              target="_blank"
                                              style={{
                                                fontWeight: "600",
                                              }}
                                            >
                                              View
                                            </Button>
                                          </>
                                        ) : null} */}
                                        <Zoom>
                                          <img
                                            src={
                                              process.env.REACT_APP_IMAGE_URL +
                                              "/" +
                                              item.pdf
                                            }
                                            alt="product-image"
                                            width="60"
                                          />
                                        </Zoom>
                                      </TableCell>
                                      <TableCell>
                                        <IconButton
                                          aria-label="edit"
                                          color="primary"
                                          onClick={() => getProductDb(item.id)}
                                        >
                                          <CreateIcon />
                                        </IconButton>
                                        <IconButton
                                          aria-label="delete"
                                          color="error"
                                          onClick={() =>
                                            deleteProductDb(item.id)
                                          }
                                        >
                                          <DeleteIcon />
                                        </IconButton>
                                      </TableCell>
                                    </TableRow>
                                  )
                                )}
                              {dummyList.dummyItems &&
                                dummyList.dummyItems.map((item, index) => (
                                  <TableRow key={index}>
                                    <TableCell>{item.area}</TableCell>
                                    <TableCell>{item.name}</TableCell>
                                    <TableCell>{item.type}</TableCell>
                                    <TableCell>{item.uom}</TableCell>
                                    <TableCell>{item.qty}</TableCell>
                                    <TableCell>{item.rate}</TableCell>
                                    <TableCell>{item.amount}</TableCell>
                                    <TableCell>
                                      <Zoom>
                                        <img
                                          src={
                                            process.env.REACT_APP_IMAGE_URL +
                                            "/" +
                                            item.image
                                          }
                                          alt="product-image"
                                          width="60"
                                        />
                                      </Zoom>
                                    </TableCell>
                                    <TableCell>
                                      {item.pdf ? (
                                        <>
                                          <Button
                                            href={
                                              process.env.REACT_APP_IMAGE_URL +
                                              "/" +
                                              item.pdf
                                            }
                                            variant="text"
                                            target="_blank"
                                            style={{
                                              fontWeight: "600",
                                            }}
                                          >
                                            View
                                          </Button>
                                        </>
                                      ) : null}
                                    </TableCell>
                                    <TableCell>
                                      <IconButton
                                        aria-label="edit"
                                        color="primary"
                                        onClick={() => getProduct(item.id)}
                                      >
                                        <CreateIcon />
                                      </IconButton>
                                      <IconButton
                                        aria-label="delete"
                                        color="error"
                                        onClick={() => deleteProduct(item.id)}
                                      >
                                        <DeleteIcon />
                                      </IconButton>
                                    </TableCell>
                                  </TableRow>
                                ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        style={{ textAlign: "right", marginBottom: "20px" }}
                      >
                        <Button
                          type="submit"
                          variant="contained"
                          color="secondary"
                        >
                          Update
                        </Button>
                      </Grid>
                    </Grid>
                  </Form>
                )}
              </Formik>
            </Card>
          </Grid>
        </Grid>
      </Container>
      {/* Authentication Modal Start*/}
      <BootstrapDialog
        onClose={handleCloseAuthentication}
        aria-labelledby="customized-dialog-title"
        open={openAuthentication}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleCloseAuthentication}
        >
          Authentication
        </BootstrapDialogTitle>
        <DialogContent dividers style={{ width: "500px" }}>
          <Formik
            initialValues={{
              password: "",
            }}
            onSubmit={async (values) => {
              if (values.password == "INTERIAH@PT123") {
                handleOpenAdd(true);
                handleCloseAuthentication(true);
              } else {
                toast.warn("Invalid Password");
              }
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
            }) => (
              <Form onSubmit={handleSubmit}>
                <Grid container>
                  <Grid item xs={12} className="form-custom">
                    <TextField
                      id="password"
                      variant="standard"
                      label="Password"
                      type="password"
                      placeholder="Enter Password"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      className="w-100 mb-15"
                      onChange={handleChange}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <DialogActions>
                    {/* <Button onClick={handleCloseAuthentication}>cancel</Button> */}
                    <Button type="submit" variant="contained" color="primary">
                      Submit
                    </Button>
                  </DialogActions>
                </Grid>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </BootstrapDialog>
      {/* Authentication Modal End */}
      {/* Product Type Modal Start*/}
      <BootstrapDialog
        onClose={handleCloseAdd}
        aria-labelledby="customized-dialog-title"
        open={openAdd}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleCloseAdd}
        >
          Product Type
        </BootstrapDialogTitle>
        <DialogContent dividers style={{ width: "500px" }}>
          <Formik
            initialValues={{
              name: "",
            }}
            onSubmit={async (values) => {
              dispatch(addProductType(values));
              handleCloseAdd(true);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
            }) => (
              <Form onSubmit={handleSubmit}>
                <Grid container>
                  <Grid item xs={12} className="form-custom">
                    <TextField
                      id="name"
                      variant="standard"
                      label="Product Type"
                      placeholder="Enter Product Type"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      className="w-100 mb-15"
                      onChange={handleChange}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <DialogActions>
                    {/* <Button onClick={handleCloseAdd}>cancel</Button> */}
                    <Button type="submit" variant="contained" color="primary">
                      Submit
                    </Button>
                  </DialogActions>
                </Grid>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </BootstrapDialog>
      {/* Product Type Modal End */}
      {/* Add Product Modal Start*/}
      <BootstrapDialog
        onClose={handleCloseProductModel}
        aria-labelledby="customized-dialog-title"
        open={openProductModel}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleCloseProductModel}
        >
          Add Product
        </BootstrapDialogTitle>
        <DialogContent dividers style={{ width: "500px" }}>
          <Formik
            enableReinitialize={true}
            initialValues={{
              quotation_id: id.id,
              rndno: localStorage.getItem("rndno"),
              area: newArea,
              product_name: "",
              type: "",
              uom: "",
              qty: "",
              rate: "",
              pdf: "",
              image: "",
            }}
            onSubmit={async (values) => {
              console.log(values);
              dispatch(addDummyProduct(values));
              setSelectedImage(null);
              handleCloseProductModel(true);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            }) => (
              <Form onSubmit={handleSubmit}>
                <Grid container>
                  <Grid item xs={12} className="form-custom">
                    <TextField
                      id="area"
                      variant="standard"
                      label="Area"
                      type="text"
                      placeholder="Enter Area"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      className="w-100 mb-15"
                      value={values.area}
                      onChange={(event) => {
                        handleChange(event);
                        setArea(event.target.value);
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} className="form-custom">
                    <TextField
                      id="product_name"
                      variant="standard"
                      label="Product Name"
                      type="text"
                      placeholder="Enter Product Name"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      className="w-100 mb-15"
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={5} className="form-custom">
                    <TextField
                      id="type"
                      name="type"
                      select
                      label="Select Product Type"
                      defaultValue="Furniture Crafting Product"
                      variant="standard"
                      className="w-100"
                      onChange={handleChange}
                    >
                      {productType.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={1} className="form-custom">
                    <AddCircleIcon
                      color="primary"
                      onClick={handleOpenAuthentication}
                    />
                  </Grid>

                  <Grid item xs={6} className="form-custom">
                    <TextField
                      id="uom"
                      name="uom"
                      select
                      label="Select UOM"
                      defaultValue="Furniture Crafting Product"
                      variant="standard"
                      className="w-100"
                      onChange={handleChange}
                    >
                      {uoms.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={6} className="form-custom">
                    <TextField
                      id="qty"
                      name="qty"
                      variant="standard"
                      label="Qty"
                      type="text"
                      placeholder="Enter Qty"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      className="w-100 mb-15"
                      onChange={(event) => {
                        handleChange(event);
                        calculate(event);
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} className="form-custom">
                    <TextField
                      id="rate"
                      name="rate"
                      variant="standard"
                      label="Rate"
                      type="text"
                      placeholder="Enter Rate"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      className="w-100 mb-15"
                      onChange={(event) => {
                        handleChange(event);
                        calculate(event);
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} className="form-custom">
                    <TextField
                      id="amount"
                      name="amount"
                      variant="standard"
                      label="Amount"
                      type="text"
                      placeholder="Enter Amount"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      className="w-100 mb-15"
                      // onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <div style={{ display: "flex" }}>
                      <input
                        accept="image/*"
                        type="file"
                        id="select-image"
                        style={{ display: "none" }}
                        onChange={(e) => {
                          setSelectedImage(e.target.files[0]);
                          setFieldValue("image", e.target.files[0]);
                        }}
                      />
                      <label htmlFor="select-image">
                        <Button
                          variant="contained"
                          color="primary"
                          component="span"
                        >
                          <FileUploadOutlinedIcon /> Upload Ref Image
                        </Button>
                      </label>
                      {imageUrl && selectedImage && (
                        <Zoom>
                          <img
                            src={imageUrl}
                            alt={selectedImage.name}
                            height="40px"
                            style={{ marginLeft: "20px" }}
                          />
                        </Zoom>
                      )}
                    </div>
                  </Grid>
                  <Grid item xs={6} style={{ marginTop: "10px" }}>
                    <p>
                      <strong>Upload Drawing</strong>
                    </p>
                    <TextField
                      className="w-100 mb-15"
                      variant="standard"
                      type="file"
                      name="pdf"
                      accept="image/*"
                      onChange={(event) => {
                        setFieldValue("pdf", event.target.files[0]);
                      }}
                      style={{ paddingTop: "10px" }}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <DialogActions>
                    <Button type="submit" variant="contained" color="primary">
                      Submit
                    </Button>
                  </DialogActions>
                </Grid>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </BootstrapDialog>
      {/* Add Product Modal End */}
      {/* Edit Product Modal Start*/}
      <BootstrapDialog
        onClose={handleCloseProductModelEdit}
        aria-labelledby="customized-dialog-title"
        open={openProductModelEdit}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleCloseProductModelEdit}
        >
          Edit Product
        </BootstrapDialogTitle>
        <DialogContent dividers style={{ width: "500px" }}>
          <Formik
            enableReinitialize={true}
            initialValues={{
              id: dummyList.singleItem.id,
              quotation_id: id.id,
              area: dummyList.singleItem.area,
              product_name: dummyList.singleItem.name,
              type: dummyList.singleItem.type,
              uom: dummyList.singleItem.uom,
              qty: dummyList.singleItem.qty,
              rate: dummyList.singleItem.rate,
              pdf: "",
              image: "",
            }}
            onSubmit={async (values) => {
              console.log(values);
              dispatch(updateDummyProduct(values));
              handleCloseProductModelEdit(true);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            }) => (
              <Form onSubmit={handleSubmit}>
                <Grid container>
                  <Grid item xs={12} className="form-custom">
                    <TextField
                      id="area"
                      variant="standard"
                      label="Area"
                      type="text"
                      placeholder="Enter Area"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      className="w-100 mb-15"
                      value={values.area}
                      onChange={(event) => {
                        handleChange(event);
                        setArea(event.target.value);
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} className="form-custom">
                    <TextField
                      id="product_name"
                      variant="standard"
                      label="Product Name"
                      type="text"
                      placeholder="Enter Product Name"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={values.product_name}
                      className="w-100 mb-15"
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={5} className="form-custom">
                    <TextField
                      id="type"
                      name="type"
                      select
                      label="Select Product Type"
                      defaultValue={values.type}
                      variant="standard"
                      className="w-100"
                      value={values.type}
                      onChange={handleChange}
                    >
                      {productType.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={1} className="form-custom">
                    <AddCircleIcon
                      color="primary"
                      onClick={handleOpenAuthentication}
                    />
                  </Grid>

                  <Grid item xs={6} className="form-custom">
                    <TextField
                      id="uom"
                      name="uom"
                      select
                      label="Select UOM"
                      defaultValue={values.uom}
                      variant="standard"
                      className="w-100"
                      value={values.uom}
                      onChange={handleChange}
                    >
                      {uoms.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={6} className="form-custom">
                    <TextField
                      id="qty"
                      name="qty"
                      variant="standard"
                      label="Qty"
                      type="text"
                      placeholder="Enter Qty"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      className="w-100 mb-15"
                      onChange={(event) => {
                        handleChange(event);
                        calculate(event);
                      }}
                      value={values.qty}
                    />
                  </Grid>
                  <Grid item xs={6} className="form-custom">
                    <TextField
                      id="rate"
                      name="rate"
                      variant="standard"
                      label="Rate"
                      type="text"
                      placeholder="Enter Rate"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      className="w-100 mb-15"
                      onChange={(event) => {
                        handleChange(event);
                        calculate(event);
                      }}
                      value={values.rate}
                    />
                  </Grid>
                  <Grid item xs={6} className="form-custom">
                    <TextField
                      id="amount"
                      name="amount"
                      variant="standard"
                      label="Amount"
                      type="text"
                      placeholder="Enter Amount"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      className="w-100 mb-15"
                      value={amount}
                    />
                  </Grid>
                  <Grid item xs={12} className="form-custom">
                    <small>Uploaded Image</small>
                    <br></br>
                    {values.image != null ? (
                      <Zoom>
                        <img
                          src={
                            process.env.REACT_APP_IMAGE_URL +
                            "/" +
                            dummyList.singleItem.image
                          }
                          alt="image"
                          width="50"
                          height="50"
                          style={{ marginTop: "10px" }}
                        />
                      </Zoom>
                    ) : null}
                  </Grid>
                  <Grid item xs={12}>
                    <div style={{ display: "flex" }}>
                      <input
                        accept="image/*"
                        type="file"
                        id="select-image"
                        style={{ display: "none" }}
                        onChange={(e) => {
                          setSelectedImage(e.target.files[0]);
                          setFieldValue("image", e.target.files[0]);
                        }}
                      />
                      <label htmlFor="select-image">
                        <Button
                          variant="contained"
                          color="primary"
                          component="span"
                        >
                          <FileUploadOutlinedIcon /> Upload Image
                        </Button>
                      </label>
                      {imageUrl && selectedImage && (
                        <Zoom>
                          <img
                            src={imageUrl}
                            alt={selectedImage.name}
                            height="40px"
                            style={{ marginLeft: "20px" }}
                          />
                        </Zoom>
                      )}
                    </div>
                  </Grid>
                  <Grid item xs={6} style={{ marginTop: "10px" }}>
                    <p>
                      <strong>Upload Pdf</strong>
                    </p>
                    <TextField
                      className="w-100 mb-15"
                      variant="standard"
                      type="file"
                      name="pdf"
                      onChange={(event) => {
                        setFieldValue("pdf", event.target.files[0]);
                      }}
                      style={{ paddingTop: "10px" }}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <DialogActions>
                    {/* <Button onClick={handleCloseAuthentication}>cancel</Button> */}
                    <Button type="submit" variant="contained" color="primary">
                      Submit
                    </Button>
                  </DialogActions>
                </Grid>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </BootstrapDialog>
      {/* Edit Product Modal End */}
      {/* Edit Product Modal Db Start*/}
      <BootstrapDialog
        onClose={handleCloseProductModelEditDb}
        aria-labelledby="customized-dialog-title"
        open={openProductModelEditDb}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleCloseProductModelEditDb}
        >
          Edit Product
        </BootstrapDialogTitle>
        <DialogContent dividers style={{ width: "500px" }}>
          <Formik
            enableReinitialize={true}
            initialValues={{
              id: makeQuotationList.quotationSingleProduct.id,
              quotation_id: id.id,
              area: makeQuotationList.quotationSingleProduct.area,
              product_name:
                makeQuotationList.quotationSingleProduct.product_name,
              type: makeQuotationList.quotationSingleProduct.product_type,
              uom: makeQuotationList.quotationSingleProduct.uom,
              qty: makeQuotationList.quotationSingleProduct.qty,
              rate: makeQuotationList.quotationSingleProduct.rate,
              pdf: "",
              image: "",
            }}
            onSubmit={async (values) => {
              // console.log(values);
              dispatch(updateQuotationSingleProduct(values));
              handleCloseProductModelEditDb(true);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            }) => (
              <Form onSubmit={handleSubmit}>
                <Grid container>
                  <Grid item xs={12} className="form-custom">
                    <TextField
                      id="area"
                      variant="standard"
                      label="Area"
                      type="text"
                      placeholder="Enter Area"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      className="w-100 mb-15"
                      value={values.area}
                      onChange={(event) => {
                        handleChange(event);
                        setArea(event.target.value);
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} className="form-custom">
                    <TextField
                      id="product_name"
                      variant="standard"
                      label="Product Name"
                      type="text"
                      placeholder="Enter Product Name"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={values.product_name}
                      className="w-100 mb-15"
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={5} className="form-custom">
                    <TextField
                      id="type"
                      name="type"
                      select
                      label="Select Product Type"
                      defaultValue={values.type}
                      variant="standard"
                      className="w-100"
                      value={values.type}
                      onChange={handleChange}
                    >
                      {productType.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={1} className="form-custom">
                    <AddCircleIcon
                      color="primary"
                      onClick={handleOpenAuthentication}
                    />
                  </Grid>

                  <Grid item xs={6} className="form-custom">
                    <TextField
                      id="uom"
                      name="uom"
                      select
                      label="Select UOM"
                      defaultValue={values.uom}
                      variant="standard"
                      className="w-100"
                      value={values.uom}
                      onChange={handleChange}
                    >
                      {uoms.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={6} className="form-custom">
                    <TextField
                      id="qty"
                      name="qty"
                      variant="standard"
                      label="Qty"
                      type="text"
                      placeholder="Enter Qty"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      className="w-100 mb-15"
                      onChange={(event) => {
                        handleChange(event);
                        calculate(event);
                      }}
                      value={values.qty}
                    />
                  </Grid>
                  <Grid item xs={6} className="form-custom">
                    <TextField
                      id="rate"
                      name="rate"
                      variant="standard"
                      label="Rate"
                      type="text"
                      placeholder="Enter Rate"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      className="w-100 mb-15"
                      onChange={(event) => {
                        handleChange(event);
                        calculate(event);
                      }}
                      value={values.rate}
                    />
                  </Grid>
                  <Grid item xs={6} className="form-custom">
                    <TextField
                      id="amount"
                      name="amount"
                      variant="standard"
                      label="Amount"
                      type="text"
                      placeholder="Enter Amount"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      className="w-100 mb-15"
                      value={amount}
                    />
                  </Grid>
                  <Grid item xs={12} className="form-custom">
                    <small>Uploaded Image</small>
                    <br></br>
                    {values.image != null ? (
                      <Zoom>
                        <img
                          src={
                            process.env.REACT_APP_IMAGE_URL +
                            "/" +
                            dummyList.singleItem.image
                          }
                          alt="image"
                          width="50"
                          height="50"
                          style={{ marginTop: "10px" }}
                        />
                      </Zoom>
                    ) : null}
                  </Grid>
                  <Grid item xs={12}>
                    <div style={{ display: "flex" }}>
                      <input
                        accept="image/*"
                        type="file"
                        id="select-image"
                        style={{ display: "none" }}
                        onChange={(e) => {
                          setSelectedImage(e.target.files[0]);
                          setFieldValue("image", e.target.files[0]);
                        }}
                      />
                      <label htmlFor="select-image">
                        <Button
                          variant="contained"
                          color="primary"
                          component="span"
                        >
                          <FileUploadOutlinedIcon /> Upload Image
                        </Button>
                      </label>
                      {imageUrl && selectedImage && (
                        <Zoom>
                          <img
                            src={imageUrl}
                            alt={selectedImage.name}
                            height="40px"
                            style={{ marginLeft: "20px" }}
                          />
                        </Zoom>
                      )}
                    </div>
                  </Grid>
                  <Grid item xs={6} style={{ marginTop: "10px" }}>
                    <p>
                      <strong>Upload Pdf</strong>
                    </p>
                    <TextField
                      className="w-100 mb-15"
                      variant="standard"
                      type="file"
                      name="pdf"
                      onChange={(event) => {
                        setFieldValue("pdf", event.target.files[0]);
                      }}
                      style={{ paddingTop: "10px" }}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <DialogActions>
                    {/* <Button onClick={handleCloseAuthentication}>cancel</Button> */}
                    <Button type="submit" variant="contained" color="primary">
                      Submit
                    </Button>
                  </DialogActions>
                </Grid>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </BootstrapDialog>
      {/* Edit Product Modal Db End */}
    </>
  );
};

export default EditQuotation;
